// extracted by mini-css-extract-plugin
export default {"menuBlock":"fG-z","title":"gG-z","nav":"hG-z","flexCell":"iG-z","facetLink":"jG-z"};